import { render, staticRenderFns } from "./highlightsNews-omn.vue?vue&type=template&id=1ff45dac&scoped=true&"
import script from "./highlightsNews-omn.vue?vue&type=script&lang=js&"
export * from "./highlightsNews-omn.vue?vue&type=script&lang=js&"
import style0 from "./highlightsNews-omn.vue?vue&type=style&index=0&id=1ff45dac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff45dac",
  null
  
)

export default component.exports